import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import './styles.scss';
import useIndicarParceriaModal from './useIndicarParceriaModalHook';

export default function IndicarParceriaModal({ open, onClose }) {
  const { link, copiarLink, modalAbertoMsg, textoCopiado, setModalAbertoMsg } =
    useIndicarParceriaModal();

  return (
    <>
      <Modal open={open} onClose={onClose} className="indicar-parceria-modal" disableAutoFocus>
        <Box>
          <Box className="indicar-parceria-modal-container">
            <div className="indicar-parceria-modal-header">
              <Typography component="h2" className="indicar-parceria-modal-title">
                Indicar parceria
              </Typography>
              <IconButton
                aria-label="fechar"
                className="indicar-parceria-modal-close-btn"
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <Box className="indicar-parceria-modal-main">
              <Typography className="indicar-parceria-modal-description">
                Faça parte do crescimento da Plataforma! Indique a One7 para seus contatos usando o link
                abaixo. Vamos juntos criar novas oportunidades de negócios!
              </Typography>

              <Box className="indicar-parceria-modal-shape">
                <Box className="indicar-parceria-modal-link">
                  <LinkSharpIcon /> <p>{link}</p>
                </Box>
                <Tooltip
                  className="tooltip"
                  placement="top"
                  title={textoCopiado ? 'Copiado!' : 'Copiar'}
                >
                  <Button onClick={() => copiarLink()}>
                    <ContentCopyIcon />
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </Box>
          <Snackbar
            open={modalAbertoMsg}
            autoHideDuration={5000}
            onClose={() => setModalAbertoMsg(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert severity="error" onClose={() => setModalAbertoMsg(false)}>
              Ocorreu um erro ao copiar o link.
            </Alert>
          </Snackbar>
        </Box>
      </Modal>
    </>
  );
}
